/**
 * Services Data for Just One PC Repair
 * Author: MCGdev
 * 
 * Extracted for better performance and SEO
 * Each service includes:
 * - id: Unique identifier
 * - icon: Icon component name (string)
 * - title: Service name
 * - description: Short description
 * - details: Array of detailed features
 * - keywords: SEO keywords
 * - darkColor: Tailwind classes for dark mode
 * - lightColor: Tailwind classes for light mode
 */

export const servicesData = [
  {
    id: 'pc-laptop-repair',
    icon: 'Desktop',
    title: "PC & Laptop Repair",
    description: "Complete hardware and software solutions for all computer issues",
    details: [
      "Diagnose and repair hardware failures like overheating, power issues, and screen problems",
      "Fix software glitches, driver updates, and OS reinstalls",
      "Upgrade components like RAM, SSD, and hard drives for better performance",
      "Network troubleshooting and Wi-Fi setup"
    ],
    keywords: ['computer repair', 'laptop repair', 'PC repair', 'hardware repair', 'software repair', 'Rosario Batangas'],
    darkColor: 'text-cyan-400 drop-shadow-[0_0_12px_rgba(34,211,238,0.9)] drop-shadow-[0_0_20px_rgba(34,211,238,0.6)]',
    lightColor: 'text-blue-600 drop-shadow-[0_0_8px_rgba(37,99,235,0.7)]'
  },
  {
    id: 'gaming-pcs',
    icon: 'GameController',
    title: "Gaming PCs",
    description: "Custom gaming PC builds and performance upgrades",
    details: [
      "Custom PC builds for gaming with high-performance components",
      "Upgrade GPUs, CPUs, RAM, and cooling systems for better frame rates",
      "Optimize game settings and install gaming peripherals",
      "Performance tuning and overclocking services"
    ],
    keywords: ['gaming PC', 'custom PC build', 'GPU upgrade', 'gaming computer', 'PC gaming Batangas'],
    darkColor: 'text-emerald-400 drop-shadow-[0_0_12px_rgba(52,211,153,0.9)] drop-shadow-[0_0_20px_rgba(52,211,153,0.6)]',
    lightColor: 'text-green-600 drop-shadow-[0_0_8px_rgba(22,163,74,0.7)]'
  },
  {
    id: 'printer-repair',
    icon: 'Printer',
    title: "Printer Repair",
    description: "Professional printer repair and maintenance services",
    details: [
      "Repair inkjet, laser, and all-in-one printers",
      "Fix paper jams, connectivity issues, and replace cartridges or faulty parts",
      "Clean printheads and resolve print quality issues",
      "Setup wireless printing and network configuration"
    ],
    keywords: ['printer repair', 'inkjet printer', 'laser printer', 'printer maintenance', 'printer fix Rosario'],
    darkColor: 'text-violet-400 drop-shadow-[0_0_12px_rgba(167,139,250,0.9)] drop-shadow-[0_0_20px_rgba(167,139,250,0.6)]',
    lightColor: 'text-purple-600 drop-shadow-[0_0_8px_rgba(147,51,234,0.7)]'
  },
  {
    id: 'data-recovery',
    icon: 'Database',
    title: "Data Recovery",
    description: "Professional data recovery from damaged storage devices",
    details: [
      "Recover lost data from crashed hard drives, SSDs, or corrupted files",
      "Use professional tools to retrieve photos, documents, and important files safely",
      "Handle physically damaged drives and logical failures",
      "Secure data transfer to new storage devices"
    ],
    keywords: ['data recovery', 'hard drive recovery', 'file recovery', 'SSD recovery', 'data rescue Batangas'],
    darkColor: 'text-rose-400 drop-shadow-[0_0_12px_rgba(244,114,182,0.9)] drop-shadow-[0_0_20px_rgba(244,114,182,0.6)]',
    lightColor: 'text-pink-600 drop-shadow-[0_0_8px_rgba(219,39,119,0.7)]'
  },
  {
    id: 'password-reset',
    icon: 'Password',
    title: "Password Reset",
    description: "Secure password recovery and account unlocking",
    details: [
      "Reset forgotten Windows passwords and unlock accounts",
      "Remove BIOS passwords safely",
      "Recover access without data loss",
      "Setup new secure passwords and account protection"
    ],
    keywords: ['password reset', 'Windows password', 'BIOS password', 'unlock account', 'password recovery'],
    darkColor: 'text-amber-400 drop-shadow-[0_0_12px_rgba(251,191,36,0.9)] drop-shadow-[0_0_20px_rgba(251,191,36,0.6)]',
    lightColor: 'text-yellow-600 drop-shadow-[0_0_8px_rgba(202,138,4,0.7)]'
  },
  {
    id: 'virus-removal',
    icon: 'Bug',
    title: "Virus Removal & System Configuration",
    description: "Malware removal and system optimization services",
    details: [
      "Remove viruses, malware, ransomware, and spyware",
      "Fix blue screen errors (BSOD) and system crashes",
      "Optimize system performance and startup speed",
      "Configure networks, VPNs, and security software"
    ],
    keywords: ['virus removal', 'malware removal', 'system optimization', 'network configuration', 'antivirus Rosario'],
    darkColor: 'text-fuchsia-400 drop-shadow-[0_0_12px_rgba(232,121,249,0.9)] drop-shadow-[0_0_20px_rgba(232,121,249,0.6)]',
    lightColor: 'text-indigo-600 drop-shadow-[0_0_8px_rgba(79,70,229,0.7)]'
  }
];

export default servicesData;
